import { HttpContextToken } from "@angular/common/http";
import { IToastType } from "@shared/components/notyf-toast/enums/toast-type";
import { IToastMsgHttpContext } from "../interfaces/toast-msg-http-context";

/**
 * Http Context Token for Bypass Toast
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Bypass Toast
 * @description Http Context Token for Bypass Toast
 * @example
 * ```typescript
 * const bypassToastContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const BYPASS_TOAST_CONTEXT = new HttpContextToken<boolean>(() => false);

/**
 * Http Context Token for Toast Messages
 * @public
 * @static
 * @returns {HttpContextToken<IToastMsgHttpContext>} Http Context Token for Toast Messages
 * @description Http Context Token for Toast Messages
 * @example
 * ```typescript
 * const toastMessageContext = new HttpContextToken<IToastMsgHttpContext | null>(() => null);
 * ```
 */
export const TOAST_MESSAGE_CONTEXT = new HttpContextToken<IToastMsgHttpContext | null>(() => null);

/**
 * Http Context Token for Bypass Toast Force
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Toast Force
 * @description Http Context Token for Toast Force
 * @example
 * ```typescript
 * const TOAST_FORCE_CONTEXT = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const TOAST_FORCE_CONTEXT = new HttpContextToken<boolean>(() => false);

/**
 * Http Context Token for Toast Message Response Key
 * @public
 * @static
 * @returns {HttpContextToken<string | null>} Http Context Token for Toast Message Response Key
 * @description Field inside the response `data` object holding the message to
 * toast, either a single key or a dot-path into nested data. For endpoints that
 * word the message themselves but return it alongside other data instead of as
 * a bare string.
 * @example
 * ```typescript
 * const TOAST_MESSAGE_KEY_CONTEXT = new HttpContextToken<string | null>(() => null);
 * ```
 */
export const TOAST_MESSAGE_KEY_CONTEXT = new HttpContextToken<string | null>(() => null);